
export const URL_BACK = '';
export const CREATE_USER = 'CREATE_USER';
export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_CATEGORIES = "GET_CATEGORIES"
export const UPDATE_USERS = 'UPDATE_USERS'
export const ASC = "_ASC";
export const DSC = "_DSC";
export const SORT_USER_LIST_BY_TYPE = 'SORT_USER_LIST_BY_TYPE'
export const SORT_USER_LIST_BY_FIELD = 'SORT_USER_LIST_BY_FIELD'
export const FILTER_USER_LIST_BY_ADMIN = 'FILTER_USER_LIST_BY_ADMIN'
export const FILTER_USER_LIST_BY_PREMIUM = 'FILTER_USER_LIST_BY_PREMIUM'
export const FILTER_USER_LIST_BY_ACTIVE = 'FILTER_USER_LIST_BY_ACTIVE'
export const ADD_LIKES = 'ADD_LIKES';
export const DELETE_LIKES = 'DELETE_LIKES';
export const GET_QUESTIONLIST= "GET_QUESTIONSLIST";
export const ADD_QUESTION= "ADD_QUESTION";
export const GET_DETAILS= "GET_DETAILS"
export const FILTER_CATEGORY = "FILTER_BY_CATEGORY"
export const FILTER_CATEGORY2= "FILTER_BY_CATEGORY2"
export const FILTER_RATING = "FILTER_BY_RATING"
export const LOGICALDELETEQ = "LOGICALDELETEQ"
export const LOGICALDELETEU = "LOGICALDELETEU"
export const ADD_RATING =  "ADD_RATING"
export const CHANGE_RATING = 'CHANGE_RATING'
export const SEARCH_QUESTION = "SEARCH_QUESTION"
export const GET_ERROR = "GET_ERROR"

